import { render, staticRenderFns } from "./DraggableListsLayers.vue?vue&type=template&id=3615c7ac&scoped=true&"
import script from "./DraggableListsLayers.vue?vue&type=script&lang=js&"
export * from "./DraggableListsLayers.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsLayers.vue?vue&type=style&index=0&id=3615c7ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615c7ac",
  null
  
)

export default component.exports